import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BarcodeScannerComponent from 'react-qr-barcode-scanner';
import {
  barCodeScan,
  stockInByBarCode,
  changeBarCodeStateLocal,
} from '../../store/actions/barCodeScan/barCodeScan.action';
import { setToasterMessage } from '../../store/actions/commonAction/common.action';
import { STOCK_IN_OPTIONS } from '../../utils/constants/values.constants';
import AlertBox from '../../common/showAlert';
import loaderImg from '../../assets/img/loader.png';
import BarCode from '../../assets/img/barcode.png';
import CloseArrow from './images/close-icon.png';

const ScanBarCode = ({
  barCodeScanSuccess,
  selectedLocationId,
  barCodeClose,
}) => {
  const barCodeRegSuccess = useSelector(
    (state) => state.barCodeReducer.barCodeReg
  );
  const scanSuccess = useSelector((state) => state.barCodeReducer.barCodeScan);
  const toasterType = useSelector((state) => state.commonReducer.toasterType);
  const showToaster = useSelector((state) => state.commonReducer.showToaster);
  const toasterMessage = useSelector(
    (state) => state.commonReducer.toasterMessage
  );
  const isProcessing = useSelector(
    (state) => state.barCodeReducer.isProcessing
  );
  const uiRulesData = useSelector(
    (state) => state.inventoryManagementReducer.uiRulesData
  );
  const stockInByLabel = STOCK_IN_OPTIONS[uiRulesData.stockInBy].label;

  const dispatch = useDispatch();
  const [, setAppointmentId] = useState('');
  const [stockInParam, setStockInParam] = useState('');
  const [isVisible, setIsvisible] = useState(false);
  const showScan = () => setIsvisible(true);

  const updateResult = (err, result) => {
    if (result) {
      let saveLocationCode = { locationCode: selectedLocationId };
      const params = new URLSearchParams();
      params.append('action', 'STOCK_IN');
      params.append('comment', '');
      setAppointmentId(result.text);
      dispatch(
        barCodeScan(saveLocationCode, result.text, '?' + params.toString())
      );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let saveLocationCode = { locationCode: selectedLocationId };
    const params = new URLSearchParams();
    params.append('action', 'STOCK_IN');
    params.append('comment', 'stock-in');

    dispatch(
      stockInByBarCode(
        saveLocationCode,
        uiRulesData.stockInBy,
        stockInParam,
        '?' + params.toString()
      )
    );
  };

  useEffect(() => {
    if (scanSuccess === 'success' || barCodeRegSuccess === 'success') {
      barCodeScanSuccess(true);
      setIsvisible(false);
      dispatch(changeBarCodeStateLocal());
      dispatch(
        setToasterMessage({
          showToaster: false,
          toasterMessage: '',
          toasterType: '',
          statusCode: '',
        })
      );
    }
  }, [scanSuccess, barCodeRegSuccess]);

  const closeToaster = () => {
    dispatch(
      setToasterMessage({
        showToaster: false,
        toasterMessage: '',
        toasterType: '',
        statusCode: '',
      })
    );
  };

  return (
    <>
      {showToaster && (
        <AlertBox
          ShowAlert={showToaster}
          message={toasterMessage}
          closeToaster={closeToaster}
          type={toasterType}
        />
      )}
      {isProcessing && (
        <div className="loaderSection">
          <img src={loaderImg} alt="loader" />
        </div>
      )}
      <form className="location-form">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="pageTitle">
              <span className="pageTitle backArrow">
                <img src={CloseArrow} alt="Close" onClick={barCodeClose} />
              </span>
              Click to scan for stock-in
            </h4>
          </div>
          <div className="col-lg-4">
            <div className="barcose" onClick={showScan}>
              {isVisible ? (
                <BarcodeScannerComponent
                  width={'100%'}
                  height={250}
                  onUpdate={updateResult}
                />
              ) : (
                <img src={BarCode} alt="icon" />
              )}
            </div>
          </div>

          <div className="col-lg-4">
            <div className="barOr">OR</div>
          </div>

          <div className="col-lg-12">
            <div className="form-group">
              <label>
                {stockInByLabel}
                <em>*</em>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={`Enter ${stockInByLabel}`}
                onChange={(e) => setStockInParam(e.target.value)}
                defaultValue={stockInParam}
              />
            </div>
          </div>
          <div className="col-lg-12 text-right">
            <label>&nbsp;</label>
            <button
              disabled={!stockInParam}
              className="goButton"
              onClick={(e) => {
                handleSubmit(e);
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default ScanBarCode;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
